import React, { useState, useEffect, useContext } from "react";
import API from "../api";
import BackButton from "../components/BackButton";
import Page from "../components/Page";
import StandingsView from "../components/StandingsView";
import Loader from "../components/Loader";
import { useParams } from "react-router-dom";
import { AuthContext } from "../providers/AuthProvider";
import ScrollToTop from "../components/ScrollToTop";
import { getMonthLabel } from "../helpers/user";
import StandingsSearch from "../components/StandingsSearch";
import ClientCache from "../cache";
import ArchivedStandingsSearch from "../modals/ArchivedStandingsSearch";
import { Button } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import useFetchSettings from "../hooks/useFetchSettings";
import { SettingsContext } from "../providers/SettingsProvider";

const getStandingsLabel = (round, season, clubId, teams) => {
  const koef = 2000;
  const seasonLabel = Number(season) - koef + "/" + (Number(season) - koef + 1);
  const roundNumber = Number(round);

  const prefix = `CЕЗОН ${seasonLabel}`;

  if (clubId) {
    return (
      <>
        {prefix}
        <br />
        {teams?.[clubId]?.name}
      </>
    );
  }

  if (Number.isNaN(roundNumber))
    return (
      <>
        {prefix}
        <br />
        {getMonthLabel(round)?.toUpperCase()}
      </>
    );

  return (
    <>
      {roundNumber === -1 ? (
        prefix
      ) : (
        <>
          {prefix}
          <br /> ТУР {roundNumber}
        </>
      )}
    </>
  );
};

const ArchivedStandings = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchPopup, setSearchPopup] = useState(false);
  const [searchReset, setSearchReset] = useState(0);

  useFetchSettings({ page: "archived" });

  const { user } = useContext(AuthContext);
  const { teams } = useContext(SettingsContext);

  const { season, round } = useParams();
  const [searchParams] = useSearchParams();
  const clubId = searchParams.get("clubId");

  const fetchLeague = async (selectedFavTeamId) => {
    const cacheKey = `${season}-${selectedFavTeamId}`;
    const clientCache = ClientCache.getInstance();
    const cachedItems = clientCache.get(cacheKey);
    try {
      setLoading(true);
      if (cachedItems !== null) {
        setItems(cachedItems);
      } else {
        const res = await API.fetchLeague({
          season,
          leagueId: selectedFavTeamId,
        });
        setItems(res.data);
        clientCache.set(cacheKey, res.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const fetchStandings = async () => {
    const targetRound = Number(round) === -1 ? undefined : round;
    const clientCache = ClientCache.getInstance();
    const cacheKey = `${season}-${targetRound}`;
    const cachedItems = clientCache.get(cacheKey);

    try {
      if (cachedItems !== null) {
        setItems(cachedItems);
      } else {
        setLoading(true);
        const res = await API.fetchStandings(
          targetRound,
          undefined,
          undefined,
          undefined,
          season
        );
        setItems(res.data.standings);
        clientCache.set(cacheKey, res.data.standings);
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
      setItems([]);
    }
  };

  useEffect(() => {
    if (clubId) {
      fetchLeague(clubId);
    } else {
      fetchStandings();
    }

    //eslint-disable-next-line
  }, [season, round, clubId]);

  const onClickBarTitle = () => {
    setSearchPopup(true);
  };

  const hideSearchPopup = () => {
    setSearchPopup(false);
  };

  return (
    <Page>
      <div className="page-bar">
        <div className="inner">
          <ScrollToTop />
          <div style={{ display: "flex", alignItems: "center" }}>
            <BackButton />
            <div className="bar-title">
              <Button
                style={{
                  height: 40,
                  padding: "0 8px",
                  fontSize: "1.2rem",
                  lineHeight: "1.2rem",
                  textAlign: "center",
                  textTransform: "uppercase",
                }}
                onClick={onClickBarTitle}
                variant="warning"
              >
                {getStandingsLabel(round, season, clubId, teams)}
              </Button>
            </div>
          </div>
          <StandingsSearch
            reset={searchReset}
            user={user}
            items={items}
            setItems={setItems}
          />
        </div>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <StandingsView items={items} onClickDisabled={true} />
      )}
      <ArchivedStandingsSearch
        season={season}
        show={searchPopup}
        onHide={hideSearchPopup}
        setSearchReset={setSearchReset}
      />
    </Page>
  );
};

export default ArchivedStandings;
